import { Input } from "design-react-kit";
import moment from "moment";
import { useEffect, useState, useContext } from "react";
import ModalComponent from "../../Components/ModalComponent";
import Repo from "../../Utility/Repo";
import { Link, useLocation } from "react-router-dom";
function useQuery() {
  return new URLSearchParams(useLocation().search);
}
import iconSprite from "bootstrap-italia/dist/svg/sprite.svg";
import Pagination from "../../Components/Pagination";
import Loader from "../../Components/Loader";
import Select from "../../Components/Select";
import { PROVINCE } from "../../Components/listaProvince";
import { NAZIONI } from "../../Components/listaNazioni";
import { MUNICIPI } from "../../Components/listaMunicipi";
import { TokenContext } from "../../Components/TokenContext";
import ListPaymemtsUsers from "../../Components/listPaymentsUser";
import SelectComponent from "../../Components/SelectComponent";
import { useUser } from "../../Components/UserContext";

function EditUser(props) {
  const apiToken = useContext(TokenContext);
  const [isOpen, toggleModal] = useState(false);
  const [isOpenState, toggleModalState] = useState(false);

  const [validation, setValidation] = useState(false);
  const [validationBirth, setValidationBirth] = useState(true);
  const [user, setUser] = useState();
  const [userIsees, setUserIsees] = useState();
  const [userIseesTemp, setUserIseesTemp] = useState();
  const [userSubscriptions, setUserSubscriptions] = useState();
  const [userSubscriptionsTemp, setUserSubscriptionsTemp] = useState();
  const [loading, setLoading] = useState(true);
  const [isDisabled, setIsDisabled] = useState(true);
  const [paymentsTemp, setPaymentsTemp] = useState();
  const [payments, setPayments] = useState();
  const [userId, setUserId] = useState("");

  let query = useQuery();

  const { delegate, operator } = useUser();

  // 🔹 Formattiamo le opzioni DOPO aver ottenuto i dati

  useEffect(() => {
    setLoading(false);
    if (query.get("citizen") != null) {
      setUserId(query.get("citizen"));

      if (query.get("idTransazione") != null) {
        var data = JSON.stringify({
          idTransazione: query.get("idTransazione"),
          EsitoWisp: query.get("EsitoWisp"),
          FaultWisp: query.get("FaultWisp"),
          IdentificativoPagamenti: query.get("IdentificativoPagamenti"),
          IUV: query.get("IUV"),
        });

        Repo.postUpdatePosizioneDebitoria(apiToken, data)
          .then((response) => {
            alert(data);
            setLoading(true);
          })
          .catch((error) => {
            console.log(error);
          });
      }

      Repo.getUserOperator(apiToken, query.get("citizen"))
        .then((response) => {
          setUser(response.data);
          setUserIseesTemp(response.data.isees);
          setUserSubscriptionsTemp(response.data.subscriptions);
          setLoading(true);
          getPayments(response.data.fiscalCode);
          console.log(response.data);
        })
        .catch((error) => {
          console.log(error);
        });
    } else {
      window.location.href = props.subfolder + "/lista_utenti";
      setLoading(true);
    }
  }, []);

  const getPayments = (fiscalCode) => {
    Repo.getListPaymentOperator(apiToken, "", fiscalCode)
      .then((response) => {
        if (response.status == 200) {
          setPaymentsTemp(response.data);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const userEditValidation = () => {
    setValidation(true);
    let passedValidation = true;
    console.log("a");
    Object.entries(user).map(([key, value]) => {
      //isArray is used to exclude the isees array in the validation
      if (
        (value == "" || value == null) &&
        !Array.isArray(value) &&
        key !== "emailPec" &&
        key !== "email" &&
        key !== "phoneNumber" &&
        key !== "municipioId" &&
        key !== "firstName" &&
        key !== "last_name" &&
        key !== "fiscal_code" &&
        key !== "state" &&
        key !== "municipio"
      ) {
        passedValidation = false;
        console.log(
          " if passedValidation:" + passedValidation + " key: " + key
        );
      }
      console.log(
        " dopo if passedValidation:" + passedValidation + " key: " + key
      );
      if (key == "birthDate") {
        if (value == "" || value == null) {
          setValidationBirth(false);
          passedValidation = false;
        } else if (user.birthDate.isValid && !user.birthDate.isValid()) {
          setValidationBirth(false);
          passedValidation = false;
        }
      }
    });
    console.log(" 116 passedValidation:");
    if (passedValidation) {
      user.birthdate = moment(user.birthDate, "DD/MM/YYYY")
        .format("YYYY-MM-DD")
        .toString();

      setUser({ ...user });

      toggleModal(!isOpen);
    }
  };

  const editUserAPI = () => {
    Repo.postUpdateUser(apiToken, JSON.stringify(user))
      .then((response) => {
        if (response.status == 200) {
          window.location.reload();
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const uploadIsee = (userId) => {
    window.location.href =
      props.subfolder +
      "/lista_utenti/dati_utente/caricamento_ISEE_operatore?userId=" +
      userId;
  };



  const userState = (userId) => {
    Repo.postUpdateUserStatus(apiToken, userId)
      .then((response) => {
        if (response.status == 204) {
          window.location.reload();
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const openTicket = (userId) => {
    window.location.href =
      props.subfolder + "/lista_utenti/dati_utente/ticket?userId=" + userId;
  };

  const CambiaStatoUtenteButtonClick = () => {
    // Chiamata al metodo per cambiare lo stato dell'utente qui...
    // Dopo aver eseguito l'azione, chiudi la modale
    toggleModal();
  };

  const CambiaStatoUtente = () => {
    userState(user.id);
  };

  return (
    <>
      <h1>
        {user && user.firstName
          ? " " + user.lastName + " " + user.firstName
          : ""}
      </h1>
      <div className="row">
        <div className="clearfix col-lg-8 py-lg-2">
          <p>{user && user.state}</p>
          <p>
            In questa sezione potrai modificare i dati anagrafici del cittadino,
            visualizzare gli ISEE caricati, le iscrizioni ai bandi e lo stato
            dei pagamenti.
          </p>
        </div>

        <div className="col-lg-4 d-flex justify-content-end">
          <div>
            <button
              className="btn btn-danger ml-2"
              type="button"
              title="Attiva blocca utente"
              onClick={() => toggleModalState(true)}
            >
              {user && user.state !== "SUSPEND" ? "SOSPENDI" : "ABILITA"}
            </button>

            <button
              className="btn btn-success ml-2"
              type="button"
              title="apri/isualizza Ticket"
              onClick={() => openTicket(query.get("citizen"))}
              disabled={delegate}
            >Ticket</button>
          </div>
        </div>
      </div>

      {/*Inizio modifica dati cittadino*/}
      <div className="row mt-2">
        <div className="col-lg-4">
          <Input
            id="firstName"
            disabled={isDisabled}
            label="Nome*"
            type="text"
            name="firstName"
            value={user && user.firstName ? user.firstName : ""}
            onChange={(e) => setUser({ ...user, firstName: e.target.value })}
          />
        </div>
        <div className="col-lg-4">
          <Input
            id="last_name"
            disabled={isDisabled}
            label="Cognome*"
            type="text"
            name="last_name"
            value={user && user.lastName ? user.lastName : ""}
            onChange={(e) => setUser({ ...user, lastName: e.target.value })}
          />
        </div>
        <div className="col-lg-4">
          <Input
            id="fiscal_code"
            disabled={isDisabled}
            label="Codice Fiscale*"
            type="text"
            name="fiscal_code"
            value={user && user.fiscalCode ? user.fiscalCode : ""}
            onChange={(e) => setUser({ ...user, fiscalCode: e.target.value })}
          />
        </div>
      </div>
      <div className="row mt-2">
        <div className="col-lg-3">
          <Input
            id="birthdate"
            disabled={isDisabled}
            label="Data di Nascita*"
            type="date"
            name="birthdate"
            placeholder="gg/mm/aaaa"
            value={
              user && user.birthDate != null
                ? moment(user.birthDate, "DD/MM/YYYY")
                    .format("YYYY-MM-DD")
                    .toString()
                : ""
            }
            onChange={(e) =>
              setUser({
                ...user,
                birthDate: moment(e.target.value),
              })
            }
            {...(validation &&
              !validationBirth && {
                infoText: "Il campo non può essere vuoto!",
                className: "text-danger error_div is-invalid",
              })}
          />
        </div>
        <div className="col-lg-4">
          <Input
            id="email"
            disabled={isDisabled}
            label="Email"
            type="text"
            name="email"
            value={user && user.email ? user.email : ""}
            onChange={(e) => setUser({ ...user, email: e.target.value })}
          />
        </div>
        <div className="col-lg-3">
          <Input
            id="emailPec"
            disabled={isDisabled}
            label="Pec"
            type="text"
            name="emailPec"
            value={user && user.emailPec ? user.emailPec : ""}
            onChange={(e) => setUser({ ...user, emailPec: e.target.value })}
          />
        </div>
        <div className="col-lg-2">
          <Input
            id="phone_number"
            disabled={isDisabled}
            label="Telefono"
            type="text"
            name="phone_number"
            value={user && user.phoneNumber ? user.phoneNumber : ""}
            onChange={(e) => setUser({ ...user, phoneNumber: e.target.value })}
          />
        </div>
      </div>
      <div className="row mt-2">
        <div className="col-lg-6">
          <Input
            id="address"
            disabled={isDisabled}
            label="Indirizzo*"
            type="text"
            name="address"
            value={user && user.address ? user.address : ""}
            onChange={(e) => setUser({ ...user, address: e.target.value })}
            {...(validation &&
              !user.address && {
                infoText: "Il campo non può essere vuoto!",
                className: "text-danger error_div is-invalid",
              })}
          />
        </div>
        <div className="col-lg-3">
          <Input
            id="number"
            disabled={isDisabled}
            label="N. Civico*"
            type="text"
            name="number"
            value={user && user.addressNumber ? user.addressNumber : ""}
            onChange={(e) =>
              setUser({ ...user, addressNumber: e.target.value })
            }
            {...(validation &&
              !user.addressNumber && {
                infoText: "Il campo non può essere vuoto!",
                className: "text-danger error_div is-invalid",
              })}
          />
        </div>
        <div className="col-lg-3">
          <Input
            id="cap"
            disabled={isDisabled}
            label="CAP*"
            type="text"
            name="cap"
            value={user && user.cap ? user.cap : ""}
            onChange={(e) => setUser({ ...user, cap: e.target.value })}
            {...(validation &&
              !user.cap && {
                infoText: "Il campo non può essere vuoto!",
                className: "text-danger error_div is-invalid",
              })}
          />
        </div>
      </div>
      <div className="row mt-2">
        <div className="col-lg-4">
          <Input
            id="city"
            disabled={isDisabled}
            label="Città*"
            type="text"
            name="city"
            value={user && user.city ? user.city : ""}
            onChange={(e) => setUser({ ...user, city: e.target.value })}
            {...(validation &&
              !user.city && {
                infoText: "Il campo non può essere vuoto!",
                className: "text-danger error_div is-invalid",
              })}
          />
        </div>
        <div className="col-lg-4">
          <div className="bootstrap-select-wrapper col-12">
            <Select
              aria-label="Scegli una provincia*"
              clearText="Annulla"
              isDisabled={isDisabled}
              defaultMenuIsOpen={false}
              icon={false}
              id="selectExampleClassic"
              onChange={(e) => {
                setUser({ ...user, country: e.value });
              }}
              options={PROVINCE}
              isSearchable
              placeholder={
                user && user.country
                  ? PROVINCE.find(
                      (option) => option.value == user.country.toString()
                    )?.label || "Scegli una provincia"
                  : "Scegli un municipio"
              }
            />
          </div>
          {validation && !user.country ? (
            <small id="errorSelect" className="form-text  text-danger">
              Il campo non può essere vuoto!
            </small>
          ) : (
            <></>
          )}
        </div>
        <div className="col-lg-4">
          <SelectComponent
            options={NAZIONI}
            value={user && user.nation ? user.nation : null}
            onChange={(e) => setUser({ ...user, nation: e.value })}
            placeholder="Seleziona*"
            isDisabled={isDisabled}
            isRequired={true}
            validation={true}
            columnClass="col-12" // Classe CSS delle colonne di Bootstrap
          />
        </div>
      </div>
      <div className="col-lg-12">
        <Select
          options={MUNICIPI}
          value={user && user.municipioId ? user.municipioId : null}
          onChange={(e) => setUser({ ...user, municipioId: e.value })}
          placeholder={
            user && user.municipioId
              ? MUNICIPI.find(
                  (option) => option.value == user.municipioId.toString()
                )?.label || "Scegli un municipio"
              : "Scegli un municipio"
          }
          isDisabled={isDisabled}
          isRequired={false}
          validation={false}
          columnClass="col-12"
        />

        {/*
                <div className="bootstrap-select-wrapper col-12">
                  <Select
                    aria-label="Scegli un municipio"
                    clearText="Annulla"
                    isDisabled={isDisabled}
                    defaultMenuIsOpen={false}
                    icon={false}
                    id="selectMunicipio"
                    onChange={(e) => setUser({ ...user, municipioId: e.value })}
                    options={listaMunicipi}
                    isSearchable
                     placeholder={
                      user && user.municipio
                        ? user.municipio.name
                        : "Scegli un municipio*"
                    }
                  />
                  </div>*/}
      </div>
      <div className="row mt-2">
        {isDisabled ? (
          <div className="col-lg-12 text-right">
            <button
              type="button"
              className="btn btn-outline-primary"
              data-toggle="tooltip"
              data-placement="top"
              onClick={() => setIsDisabled(!isDisabled)}
              title="Modifica"
              disabled={delegate}
            >
              Modifica
            </button>
          </div>
        ) : (
          <>
            <div className="col-lg-12 text-right">
              <button
                type="button"
                className="btn btn-outline-secondary"
                data-toggle="tooltip"
                data-placement="top"
                onClick={() => setIsDisabled(!isDisabled)}
                title="Indietro"
              >
                Indietro
              </button>

              <button
                type="button"
                className="btn btn-outline-primary ml-2"
                data-toggle="tooltip"
                data-placement="top"
                onClick={() => userEditValidation()}
                title="Conferma"
                disabled={delegate}
              >
                Conferma
              </button>
            </div>
          </>
        )}
      </div>

      {/*Fine modifica dati cittadino*/}

      {/* inizio isee*/}
      <div className="col-lg-12 mt-3">
        <div className="card-wrapper card-space">
          <div className="card card-bg no-after card-big roundedCustom">
            <div className="card-body">
              <div className="row my-2">
                <div className="col-lg-9">
                  <h5>
                    ISEE{" "}
                    <i>
                      {user && user.firstName
                        ? " " + user.lastName + " " + user.firstName
                        : ""}
                    </i>
                  </h5>
                </div>
                <div className="col-lg-3 text-right">
                  <button
                    type="button"
                    className="btn btn-outline-primary btn-sm"
                    data-toggle="tooltip"
                    data-placement="top"
                    title="Carica ISEE per l'utente"
                    onClick={() => uploadIsee(query.get("citizen"))}
                    disabled={delegate}
                  >
                    <span>Inserisci nuovo ISEE</span>
                    <span>
                      <svg className="icon icon-primary icon-sm">
                        <use href={`${iconSprite}#it-arrow-right`} />
                      </svg>
                    </span>
                  </button>
                </div>
              </div>
              {userIseesTemp && userIseesTemp.length > 0 ? (
                <div className="row">
                  <table className="table table-hover">
                    <thead>
                      <tr>
                        <th scope="col">Valore ISEE caricato</th>
                        <th scope="col">Data inserimento</th>
                        <th scope="col">Stato</th>
                        <th>Anno</th>
                        <th scope="col"></th>
                      </tr>
                    </thead>
                    <tbody>
                      {userIsees &&
                        userIsees.length > 0 &&
                        userIsees.map((y, index) => (
                          <tr key={index} index={index}>
                            {/* <th scope="row">{x.name}</th> */}
                            <th scope="row">
                              {y.value &&
                                parseFloat(y.value).toLocaleString(
                                  "it-IT"
                                )}{" "}
                              €
                            </th>
                            <td>{y.date}</td>
                            <td>
                              {y.state == "VALIDATED" ? (
                                <>
                                  <b className="text-success">
                                    <svg className="icon icon-success">
                                      <use
                                        href={`${iconSprite}#it-check-circle`}
                                      />
                                    </svg>{" "}
                                    ACCETTATO
                                  </b>
                                </>
                              ) : y.state == "LOADED" ? (
                                <b className="">
                                  <svg className="icon">
                                    <use
                                      href={`${iconSprite}#it-close-circle`}
                                    />
                                  </svg>
                                  DA VERIFICARE
                                </b>
                              ) : y.state == "REFUSED" ? (
                                <b className="text-danger">
                                  <svg className="icon icon-danger">
                                    <use
                                      href={`${iconSprite}#it-close-circle`}
                                    />
                                  </svg>{" "}
                                  RIFIUTATO
                                </b>
                              ) : (
                                <b className="text-danger">
                                  <svg className="icon icon-danger">
                                    <use
                                      href={`${iconSprite}#it-close-circle`}
                                    />
                                  </svg>{" "}
                                  {y.state}
                                </b>
                              )}
                            </td>
                            <td>{y.year}</td>
                            <td className="text-right">
                              {y.state == "LOADED" ? (
                                <Link
                                  to={
                                    "/lista_utenti/dati_utente/verifica_isee?idIsee=" +
                                    y.id
                                  }
                                >
                                  <button
                                    className="btn btn-outline-primary p-2"
                                    data-toggle="tooltip"
                                    data-placement="top"
                                    title="Modifica"
                                  >
                                    Dettaglio
                                  </button>
                                </Link>
                              ) : (
                                <Link
                                  to={
                                    "/lista_utenti/dati_utente/visualizza_isee?idIsee=" +
                                    y.id
                                  }
                                >
                                  <button
                                    className="btn btn-outline-primary p-2"
                                    data-toggle="tooltip"
                                    data-placement="top"
                                    title="Modifica"
                                  >
                                    Dettaglio
                                  </button>
                                </Link>
                              )}
                            </td>
                          </tr>
                        ))}
                    </tbody>
                  </table>
                  {user.isees && (
                    <Pagination
                      items={userIseesTemp}
                      setCurrentItems={setUserIsees}
                      itemsPerPage={5}
                    ></Pagination>
                  )}
                </div>
              ) : (
                <>Non sono presenti ISEE per questo utente</>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* fine isee*/}

      {/* inizio iscrizioni utente*/}
      <div className="col-lg-12 mt-3">
        <div className="card-wrapper card-space">
          <div className="card card-bg no-after card-big roundedCustom">
            <div className="card-body">
              <div className="row my-2">
                <div className="col-lg-9">
                  <h5>
                    <b>Iscrizioni</b>{" "}
                    <i>
                      {user && user.firstName
                        ? " " + user.lastName + " " + user.firstName
                        : ""}
                    </i>
                  </h5>
                </div>
                {userSubscriptionsTemp && userSubscriptionsTemp.length > 0 ? (
                  <>
                    <table className="table table-hover">
                      <thead>
                        <tr>
                          <th scope="col">Titolo bando</th>
                          <th scope="col">Servizio</th>
                          <th scope="col">Stato Utente</th>
                          <th scope="col"></th>
                        </tr>
                      </thead>
                      <tbody>
                        {userSubscriptions &&
                          userSubscriptions.length > 0 &&
                          userSubscriptions.map((x, index) => (
                            <tr key={index}>
                              <td scope="row">{x.announcement.name}</td>

                              <td>{x.announcement.service.name}</td>
                              <td>
                                {x.state == "VALIDATED" ? (
                                  <div className="col-12 mt-2">
                                    <svg className="icon icon-success mr-2 mb-1">
                                      <use
                                        xlinkHref={`${iconSprite}#it-check-circle`}
                                      ></use>
                                    </svg>
                                    <b className="text-success">
                                      {"Richiesta accettata".toUpperCase()}
                                    </b>
                                  </div>
                                ) : x.state == "REFUSED" ? (
                                  <div className="col-12 mt-2">
                                    <svg className="icon icon-danger mr-2 mb-1">
                                      <use
                                        xlinkHref={`${iconSprite}#it-close-circle`}
                                      ></use>
                                    </svg>
                                    <b className="text-danger">
                                      {"Richiesta rifiutata".toUpperCase()}
                                    </b>
                                  </div>
                                ) : x.state == "SUSPENDED" ? (
                                  <div className="col-12 mt-2">
                                    <svg className="icon icon-dark mr-2 mb-1">
                                      <use
                                        xlinkHref={`${iconSprite}#it-ban`}
                                      ></use>
                                    </svg>
                                    <b className="text-dark">
                                      {"Iscrizione sospesa".toUpperCase()}
                                    </b>
                                  </div>
                                ) : x.state == "ADDED" ? (
                                  <div className="col-12 mt-2">
                                    <svg className="icon icon-warning mr-2 mb-1">
                                      <use
                                        xlinkHref={`${iconSprite}#it-warning-circle`}
                                      ></use>
                                    </svg>
                                    <b className="text-warning">
                                      {"Richiesta inviata".toUpperCase()}
                                    </b>
                                  </div>
                                ) : (
                                  <div className="col-12 mt-2">
                                    <strong className="text text-dark">
                                      NON SEI ISCRITTO
                                    </strong>
                                  </div>
                                )}
                              </td>
                              <td className="text-right">
                                <Link
                                  to={
                                    "/lista_bandi/dettaglio_sessione?id=" +
                                    x.announcement.id
                                  }
                                >
                                  <button
                                    className="btn btn-outline-primary p-2"
                                    data-toggle="tooltip"
                                    data-placement="top"
                                    title="Modifica"
                                  >
                                    Dettaglio
                                  </button>
                                </Link>
                              </td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                    {userSubscriptionsTemp && (
                      <Pagination
                        items={userSubscriptionsTemp}
                        setCurrentItems={setUserSubscriptions}
                        itemsPerPage={3}
                      ></Pagination>
                    )}
                  </>
                ) : (
                  <div className="mt-2 p-1">
                    L'utente non è iscritto a nessun bando
                  </div>
                )}

                {/* {userSubscriptionsTemp && (
                <Sessions
                  sessionsTemp={userSubscriptionsTemp}
                  sessionsList={userSubscriptions}
                  SetSessionsList={setUserSubscriptions}
                ></Sessions>
              )} */}
              </div>
            </div>
          </div>
        </div>
      </div>
      <ListPaymemtsUsers
        payments={payments}
        paymentsTemp={paymentsTemp}
        setPayments={setPayments}
        fiscalCode={true}
        userId={userId}
      />

      <ModalComponent
        toggleModal={toggleModal}
        isOpen={isOpen}
        header={
          user && "Modifica utente: " + user.firstName + " " + user.lastName
        }
        body={
          user &&
          "Confermi di voler modificare i dati di " +
            user.firstName +
            " " +
            user.lastName +
            "?"
        }
        buttonConfirm="Conferma"
        buttonDeny="Annulla"
        function={() => editUserAPI()}
      ></ModalComponent>

      <ModalComponent
        toggleModal={toggleModalState}
        isOpen={isOpenState}
        header="Cambia Stato"
        body={
          user &&
          `Confermi di voler modificare lo stato in ${
            user.state === "VALIDATED" ? "SOSPESO" : "ATTIVO"
          } di ${user.firstName} ${user.lastName}?`
        }
        buttonConfirm="Conferma"
        buttonDeny="Annulla"
        function={() => CambiaStatoUtente()}
      ></ModalComponent>

      {!loading && <Loader></Loader>}
    </>
  );
}

export default EditUser;
